import { useEffect, useMemo } from 'react';
import { Outlet } from 'react-router-dom';
import { usePortal } from '../../contexts/PortalContext';
import { DESIGN_MAIN_MODULES } from '../../lib/designModules';
import { CrmPageToastPortal } from '../notifications/CrmPageToastPortal';
import { PortalWebPushBanner } from '../notifications/PortalWebPushBanner';
import { PortalFloatingShell } from './PortalFloatingShell';
import { PortalPresenceReporter } from './PortalPresenceReporter';
import '../../styles/dem-theme-lab.css';

export function DesignAppShell() {
  const { basePath } = usePortal();

  useEffect(() => {
    const root = document.documentElement;
    root.classList.remove('has-dock');
    root.style.removeProperty('--dock-clearance');
    root.style.removeProperty('--mobile-header-clearance');
    root.style.setProperty('--dock-clearance', '0px');
    root.style.setProperty('--mobile-header-clearance', '0px');
    return () => {
      root.style.removeProperty('--dock-clearance');
      root.style.removeProperty('--mobile-header-clearance');
    };
  }, []);

  const nav = useMemo(
    () =>
      DESIGN_MAIN_MODULES.map((mod) => {
        const to = basePath ? `${basePath}/${mod.slug}` : `/${mod.slug}`;
        return {
          to,
          label: mod.label,
          icon: mod.icon,
        };
      }),
    [basePath],
  );

  return (
    <div className="app-shell app-shell--dock app-shell--design app-shell--dem-theme-lab">
      <PortalPresenceReporter portal="design" />
      <div className="main">
        <PortalWebPushBanner variant="toast" />
        <div className="page page--design">
          <PortalFloatingShell portalName="Design" portalKind="design" items={nav}>
            <Outlet />
          </PortalFloatingShell>
        </div>
      </div>
      <CrmPageToastPortal />
    </div>
  );
}
